<template>
	<div class="items-filter-container" :class="{hidden: items.length === 0}">
		<div class="item" v-for="item in items" :key="item.menu_item_id" @click="clickItem(item)">
			<p>{{ item?.name }}</p>
		</div>
	</div>
</template>

<script>
import {useMenuStore, } from "@/console-new/stores";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/user/stores";

export default {
	setup() {
		const menuStore = useMenuStore();
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		return {menuStore, getString: languageStore.getString, userStore, notificationStore};
	},
	name: "AdditionalShortcutsSelector",
	emits: ["picked-item"],
	props: {
		categoryId: Number,
	},
	data() {
		return {

		}
	},
	computed: {
		currentCategory() {
			return this.menuStore.categories?.[this.categoryId] || {};
		},
		items() {
			if(!this.currentCategory?.items) {
				return [];
			}
			let items = [];
			for(let itemId in this.currentCategory.items) {
				if(!this.currentCategory.items[itemId].deleted_item) {
					items.push({
						...this.currentCategory.items[itemId],
						title: this.currentCategory.items[itemId].name,
						customSlot: 'btn-slot',
					});
				}

			}
			return items;
		},
	},
	methods: {
		clickItem(item) {
			this.$emit("picked-item", this.menuStore.items[item.menu_item_id]);
		},
	},
}
</script>

<style lang="scss" scoped>
.items-filter-container {
	@include hideScrollbar;
	border-radius: 13px;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	padding: 8px;
	gap: 6px;
	width: 100%;
	max-width: 100%;
	height: 50px;
	overflow-x: scroll;
	background-color: var(--color-bg-primary-1);
	box-shadow: inset 2px 2px 3px var(--color-box-shadow-3);
	min-height: 56px;

	.item {
		border-radius: 13px;
		border: 1px solid var(--color-primary);
		padding: 0 6px;
		cursor: pointer;
		user-select: none;
		transition: background-color 0.3s ease;
		height: 34px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		min-width: 120px;
		max-width: 250px;

		@media (max-width: 950px) {
			min-width: 110px;
		}

		@media (max-width: 850px) {
			min-width: 95px;
		}

		@media (max-width: 750px) {
			min-width: 110px;
		}

		@media (max-width: 550px) {
			min-width: 95px;
		}

		p {
			font-size: 12px;
			color: var(--color-primary);
			@include truncateString(1);
			text-align: center;
		}

		&.active {
			background-color: var(--color-active-button);
			p {
				color: var(--color-active-button-text);
			}
		}
	}

	@media (max-width: 900px) {
		padding: 8px;
		gap: 8px;
		min-height: 56px;

		.item {
			padding: 0 8px;
		}
	}

}
</style>